import Vue from 'vue'

/**
 * Les profils d'équipement d'une organisation : comment ses bornes, compteurs et véhicules compteurs
 * fonctionnent (usage) et quelle licence ils portent. Le serveur reste juge des combinaisons.
 */
class EquipmentProfileRepository {

  // GET /api/commissioning/equipment-profiles/{organizationId}[?archived=1]
  // En GET, les paramètres passent par `data` (auth.fetch ne recopie pas `params`).
  list(organizationId, withArchived = false) {
    return this.fetch({ url: `/api/commissioning/equipment-profiles/${organizationId}`, method: 'get', data: withArchived ? { archived: 1 } : {} })
  }

  // POST { name, kind, usage, deviceTypes?, licence: { subscriptionId, formulaId, optionIds } | newSubscription: {…} } → { id, subscriptionId? }
  // Avec newSubscription (sans licence), le serveur crée l'abonnement puis le profil en une fois.
  create(organizationId, profile) {
    return this.fetch({ url: `/api/commissioning/equipment-profiles/${organizationId}`, method: 'post', data: profile })
  }

  // PATCH { name?, usage?, deviceTypes?, licence? | newSubscription?, archived? }
  update(organizationId, profileId, change) {
    return this.fetch({ url: `/api/commissioning/equipment-profiles/${organizationId}/${profileId}`, method: 'patch', data: change })
  }

  // GET /api/commissioning/device-types → { 'charging-point': [...], 'meter-device': [...] } : les sous-types par type d'équipement
  deviceTypes() {
    return this.fetch({ url: '/api/commissioning/device-types', method: 'get' })
  }

  // GET /api/commissioning/equipment-profiles/{organizationId}/subscription-plans?kind=&usage=&deviceTypes=a,b
  // Les modèles d'abonnement qui conviennent à ce profil (forme de /api/subscriptions/plans/search), avec eligibleFormulaIds.
  subscriptionPlans(organizationId, { kind, usage, deviceTypes = [] }) {
    const data = { kind, usage, ...(deviceTypes.length ? { deviceTypes: deviceTypes.join(',') } : {}) }
    return this.fetch({ url: `/api/commissioning/equipment-profiles/${organizationId}/subscription-plans`, method: 'get', data })
  }

  // GET /api/commissioning/charging-points/{id}/profile-change[?profileId=] — ce que changer de profil ferait ; sans profil, ce qu'elle est (et de quel côté)
  previewChange(chargingPointId, profileId) {
    return this.fetch({ url: `/api/commissioning/charging-points/${chargingPointId}/profile-change`, method: 'get', data: profileId ? { profileId } : {} })
  }

  // POST /api/commissioning/charging-points/{id}/profile-change { profileId }
  change(chargingPointId, profileId) {
    return this.fetch({ url: `/api/commissioning/charging-points/${chargingPointId}/profile-change`, method: 'post', data: { profileId } })
  }

  fetch(options) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch(options)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default new EquipmentProfileRepository()
